"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPusherFetchCredentialsFromApi = exports.getPusherCluster = exports.getPusherKey = exports.getDatadogRumClientToken = exports.getDatadogRumApplicationId = exports.getDatadogClientToken = exports.getFullStoryOrgId = exports.getSentryDSN = exports.getLaunchDarklyClientId = exports.getWhatsNewProjectKey = exports.getSegmentKey = void 0;

var utils_1 = require("../utils");

exports.getSegmentKey = (0, utils_1.createGetEnvVar)({
  production: 'EajF6DKepjOS0OalnKw2n0HQEy0b1D4M',
  staging: 'f251DXqkFXqbQf4GMq89okFL75grXoGB',
  local: 'nBSKPC0tMkz010ZDvUvGPkRNLygAaDN2',
  review: 'nBSKPC0tMkz010ZDvUvGPkRNLygAaDN2'
}, 'segment-key');
exports.getWhatsNewProjectKey = (0, utils_1.createGetEnvVar)({
  production: 'hopin',
  staging: 'hopin-sandbox',
  local: 'hopin-sandbox',
  review: 'hopin-sandbox'
}, 'whats-new-project-key');
exports.getLaunchDarklyClientId = (0, utils_1.createGetEnvVar)({
  production: '5eb04cd71ae17a0a740ecc57',
  staging: '5eb41a81e178470acdd2ca11',
  local: '5eb04cd71ae17a0a740ecc56',
  review: '5fc62f9b114d4d09881ae6f1'
}, 'launchDarklyClientId');
exports.getSentryDSN = (0, utils_1.createGetEnvVar)({
  production: 'https://412180245fa241549ca96543a0be9e8e@o370914.ingest.sentry.io/6231946',
  staging: 'https://412180245fa241549ca96543a0be9e8e@o370914.ingest.sentry.io/6231946',
  local: 'https://412180245fa241549ca96543a0be9e8e@o370914.ingest.sentry.io/6231946',
  review: 'https://412180245fa241549ca96543a0be9e8e@o370914.ingest.sentry.io/6231946'
}, 'sentryDSN');
exports.getFullStoryOrgId = (0, utils_1.createGetEnvVar)({
  production: '189D4Z',
  staging: '189D4Z',
  local: 'XXXXXX',
  review: 'XXXXXX' // dummy value

}, 'fullstory-org-id');
exports.getDatadogClientToken = (0, utils_1.createGetEnvVar)({
  production: 'pub8bbfaf848be08676edabfb40aeef15b4',
  staging: 'pub8bbfaf848be08676edabfb40aeef15b4',
  local: 'XXXXXX',
  review: 'XXXXXX' // dummy value

}, 'datadogClientToken');
exports.getDatadogRumApplicationId = (0, utils_1.createGetEnvVar)({
  production: '42df3921-7578-47f9-a263-ca085532e296',
  staging: '42df3921-7578-47f9-a263-ca085532e296',
  local: 'XXXXXX',
  review: 'XXXXXX' // dummy value

}, 'datadogRumApplicationId');
exports.getDatadogRumClientToken = (0, utils_1.createGetEnvVar)({
  production: 'pub9c9021ec74d502ffd2e7a313680aaf83',
  staging: 'pub9c9021ec74d502ffd2e7a313680aaf83',
  local: 'XXXXXX',
  review: 'XXXXXX' // dummy value

}, 'datadogRumClientToken');
exports.getPusherKey = (0, utils_1.createGetEnvVar)({
  production: 'd9b03d485c6d62190e94',
  staging: '00f26110e245c71efda3',
  local: '00f26110e245c71efda3',
  review: '00f26110e245c71efda3'
}, 'pusherKey');
exports.getPusherCluster = (0, utils_1.createGetEnvVar)({
  production: 'eu',
  staging: 'eu',
  local: 'eu',
  review: 'eu'
}, 'pusherCluster');
exports.getPusherFetchCredentialsFromApi = (0, utils_1.createGetEnvVar)({
  production: 'true',
  staging: 'true',
  local: 'true',
  review: 'true'
}, 'pusherFetchCredentialsFromApi');